import React from 'react';
import { Card, Stack, Chip } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { IAudition } from '../../types/global/helper';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { TextWithIcon } from '../TextWithIcon/TextWithIcon';
import GroupsIcon from '@mui/icons-material/Groups';

export interface IUnionAffiliation {
    audition: IAudition;
}

const UnionAffiliation: React.FC<IUnionAffiliation> = ({ audition }) => {
    const { themeStyle } = useThemeContext();

    // Don't render if union_affiliation is not available
    if (!audition.union_affiliation) {
        return null;
    }

    return (
        <Stack>
            <TextWithIcon
                icon={<GroupsIcon sx={{ fontSize: 18, color: theme[themeStyle].tag_white }} />}
                text="Union Affiliation"
            />
            <Card
                sx={{
                    width: '100%',
                    borderRadius: 2,
                    overflow: 'visible',
                    my: 2,
                    p: 1,
                    height: '100%',
                    backgroundColor: 'rgb(229,244,245)',
                }}>
                <Stack height="100%" direction="column" justifyContent="space-between">
                    <Stack
                        sx={{
                            backgroundColor: 'rgb(229,244,245)',
                            borderRadius: 1,
                            padding: '4px 8px',
                            width: '100%',
                            my: 1,
                        }}>
                        <Chip
                            label={audition.union_affiliation}
                            sx={{
                                backgroundColor: '#000',
                                color: theme[themeStyle].true_white,
                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                fontSize: 12,
                                height: '28px',
                                textTransform: 'capitalize',
                            }}
                        />
                    </Stack>
                </Stack>
            </Card>
        </Stack>
    );
};

export { UnionAffiliation };
